export const integerOptions = (min = 1, max = 100) =>
  Array(max - min + 1)
    .fill()
    .map((_, i) => ({
      value: (i + min).toString(),
      label: (i + min).toString(),
    }))
